export const teamMembers = [
  {
    id: 1,
    name: "Erik Carbajal-Degante",
    profession: "Lider del proyecto",
    role: "Investigador en IA Educativa",
    image: `${process.env.PUBLIC_URL}/images/team/ecd.JPG`,
    linkedin: "https://linkedin.com/in/ana-garcia",
    github: "https://github.com/erikycd"
  },
  {
    id: 2,
    name: "Marian Partida",
    profession: "Desarrolladora IA",
    role: "Matemática Aplicada",
    image: `${process.env.PUBLIC_URL}/images/team/mp.jpeg`,
    linkedin: "https://linkedin.com/in/carlos-perez",
    github: "https://github.com/carlosperez"
  },
  {
    id: 3,
    name: "Ema",
    profession: "Científico de Datos",
    role: "Matemático",
    image: `${process.env.PUBLIC_URL}/images/team/etc.jpg`,
    linkedin: "https://linkedin.com/in/carlos-perez",
    github: "https://github.com/carlosperez"
  },
  {
    id: 4,
    name: "Héctor GG",
    profession: "Desarrollador Full-Stack & Ciberseguridad",
    role: "Ingeniero en Computación",
    image: `${process.env.PUBLIC_URL}/images/team/hgg.png`,
    linkedin: "https://linkedin.com/in/carlos-perez",
    github: "https://github.com/carlosperez"
  },
  {
    id: 5,
    name: "Joel López",
    profession: "Desarrollador Back-End & Software",
    role: "Ingeniero en Computación",
    image: `${process.env.PUBLIC_URL}/images/team/jl.png`,
    linkedin: "https://linkedin.com/in/carlos-perez",
    github: "https://github.com/carlosperez"
  },
  {
    id: 6,
    name: "Denise Hernández Pelcastre",
    profession: "Diseñadora de Instrumentos de Evaluación",
    role: "Pedagoga",
    image: `${process.env.PUBLIC_URL}/images/team/dhp.png`,
    linkedin: "https://linkedin.com/in/carlos-perez",
    github: "https://github.com/carlosperez"
  },
  {
    id: 7,
    name: "Ken Bryan Guadarrama H.",
    profession: "Gestor de Proyecto & Desarrollador IA",
    role: "Ingeniero en Computación",
    image: `${process.env.PUBLIC_URL}/images/team/kgh2.png`,
    linkedin: "https://linkedin.com/in/carlos-perez",
    github: "https://github.com/carlosperez"
  },
];
